module.exports = __webpack_public_path__ + "static/media/shell32_33.2452d88f.ico";